import { DefinedQueryObserverResult } from "@tanstack/react-query";
import { ApplicationStatus, Verification } from "shared/types";
import { Applicant, Application } from "types/application";
import { CombinedIncomeProvider } from "./providers/CombinedIncomeProvider";
import { ReportContentSlice } from "./slices/ReportContentSlice";
import { ModalsSlice } from "./slices/ModalsSlice";
import { ReportHeaderSlice } from "./slices/ReportHeaderSlice";

export const CombinedIncomeReportSlice = ({
  verificationId,
  applicantId,
  applicationId,
  hasCreditReport,
  applicant,
  applicationStatus,
  activeVerification,
  applicationMeta
}: {
  verificationId?: number;
  applicantId?: number;
  applicationId?: number;
  hasCreditReport?: boolean;
  applicant: Applicant;
  applicationStatus: ApplicationStatus;
  activeVerification: Verification;
  applicationMeta: DefinedQueryObserverResult<Application | undefined, unknown>;
}) => (
  <CombinedIncomeProvider
    verificationId={verificationId}
    applicantId={applicantId}
    applicationId={applicationId}
    hasCreditReport={hasCreditReport}
    applicant={applicant}
    applicationStatus={applicationStatus}
    activeVerification={activeVerification}
    applicationMeta={applicationMeta}
  >
    <ReportHeaderSlice />
    <ReportContentSlice />
    <ModalsSlice />
  </CombinedIncomeProvider>
);
